import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

/**
 * close dropdown of filter when you click outside
 */
function useOutsideAlerter(ref: React.RefObject<ValidRefTarget>, clickFn: (value: React.SetStateAction<boolean>) => void) {
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent | TouchEvent) => {
			if (ref.current && !ref.current.contains(event.target)) {
				clickFn(false)
			}
		}
		// Bind the event listener
		document.addEventListener('mousedown', handleClickOutside)
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [ref])
}

function OutsideAlerter(props: { children: boolean | React.ReactNode | React.ReactPortal | null | undefined, clickFn: React.Dispatch<React.SetStateAction<boolean>> }) {
	const wrapperRef = useRef(null)
	useOutsideAlerter(wrapperRef, props.clickFn)

	return <div ref={wrapperRef}>{props.children}</div>
}

OutsideAlerter.propTypes = {
	children: PropTypes.element.isRequired
}
interface ValidRefTarget {
  contains(target: EventTarget | null): Element;
  event: MouseEvent| EventTarget | TouchEvent
}

export default OutsideAlerter
